import Modal from 'honeydew/Modal';

function DiscountInfoModal({ discount, onClose, open }) {
    return (
        <Modal open={open} headline="Discount" onClose={onClose}>
            <p className="text-body-sm font-grotesk-bold">{discount?.nanobarText}</p>
            {discount?.nanobarTerms && (
                <>
                    <h4 className="text-body-sm my-10 font-grotesk-bold">Terms</h4>
                    <p className="text-body-sm">{discount?.nanobarTerms}</p>
                </>
            )}
        </Modal>
    );
}

export default DiscountInfoModal;
